import { CSSObject } from '@emotion/react'
import { MOBILE, styles as sharedStyles } from '../../styles'

const getSlideStyles = (hasPhoto: boolean): CSSObject => ({
  ...sharedStyles.getSlideFrameStyles({ ...MOBILE, hasPhoto }),
  // The gradient overlays sit above an empty slot; let drops and clicks
  // reach the asset picker underneath.
  '.kuiper-tiktok-gradient-layer': {
    pointerEvents: 'none',
  },
  // The back chevron shares the top-left corner with the asset picker's
  // buttons, so it only shows once a photo is in place.
  '.kuiper-icon-tiktok-mobile-chevron-west': {
    display: hasPhoto ? 'block' : 'none',
  },
  // The hovered asset overlay (z 1000) covers the whole frame and the
  // carousel's sticky add button sits at 9999; keep the caption and sound
  // inputs above both, as the Instagram Carousel footer does.
  '.kuiper-tiktok-post-content': {
    zIndex: 10000,
  },
})

const picker = sharedStyles.getPickerStyles(MOBILE.width, MOBILE.height)

const styles = {
  getSlideStyles,
  picker,
}

export { styles }
